/* Hero CTA measurement only. Shopify Rollouts owns visitor assignment. */
(() => {
  'use strict';

  if (window.__groovHeroClarityV1 || window.Shopify?.designMode) return;
  const button = document.querySelector('.hero-model-carousel-cta');
  if (!button) return;
  window.__groovHeroClarityV1 = true;

  const experiment = 'hero_cta_v1';
  const seen = new Set();
  const clicked = new Set();
  let inView = false;
  let attempts = 0;
  let retryTimer;
  let qa = new URLSearchParams(window.location.search).get('groov_cta_qa') === '1';
  qa ||= new URLSearchParams(window.location.search).has('preview_theme_id');
  try {
    if (qa) window.sessionStorage.setItem('groov_hero_clarity_qa', '1');
    qa ||= window.sessionStorage.getItem('groov_hero_clarity_qa') === '1';
  } catch (_) { /* Measurement must also work when storage is unavailable. */ }

  function variant() {
    const label = button.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
    let url;
    try { url = new URL(button.href, window.location.href); } catch (_) { return null; }
    if (url.origin !== window.location.origin) return null;
    const path = url.pathname.replace(/\/$/, '').replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
    if (label === 'discover groov' && path === '/collections/shop-all') return 'a';
    if (label === 'take the quiz' && path === '/pages/quiz') return 'b';
    return null;
  }

  function canMeasure() {
    if (typeof window.clarity !== 'function') return false;
    const privacy = window.Shopify?.customerPrivacy;
    try {
      if (typeof privacy?.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return false;
    } catch (_) { return false; }
    return true;
  }

  function emit(currentVariant, action) {
    if (!canMeasure()) return false;
    try {
      window.clarity('set', 'groov_hero_test', experiment);
      window.clarity('set', 'groov_hero_variant', currentVariant);
      window.clarity('set', 'groov_hero_mode', qa ? 'qa' : 'live');
      window.clarity('event', `groov_hero_v1_${currentVariant}_${action}`);
      return true;
    } catch (_) { return false; }
  }

  function visible() {
    if (document.visibilityState === 'hidden' || !button.isConnected) return false;
    const style = window.getComputedStyle(button);
    if (style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0) return false;
    const rect = button.getBoundingClientRect();
    const width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
    const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
    return rect.width > 0 && rect.height > 0 && width * height / (rect.width * rect.height) >= 0.5;
  }

  function recordView() {
    const currentVariant = variant();
    if (!currentVariant || seen.has(currentVariant) || !inView || !visible()) return;
    if (emit(currentVariant, 'view')) seen.add(currentVariant);
  }

  function recordClick(event) {
    if (!event.isTrusted || (event.type === 'auxclick' && event.button !== 1)) return;
    const currentVariant = variant();
    if (!currentVariant || !visible() || !canMeasure()) return;
    // A fast click can precede the observer callback. Preserve view -> click order.
    if (!seen.has(currentVariant) && emit(currentVariant, 'view')) seen.add(currentVariant);
    if (seen.has(currentVariant) && !clicked.has(currentVariant) && emit(currentVariant, 'click')) clicked.add(currentVariant);
  }

  button.addEventListener('click', recordClick, { capture: true });
  button.addEventListener('auxclick', recordClick, { capture: true });
  document.addEventListener('visibilitychange', recordView);
  document.addEventListener('visitorConsentCollected', recordView);

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5);
      recordView();
    }, { threshold: [0, 0.5] });
    observer.observe(button);
  } else {
    inView = true;
    window.addEventListener('scroll', recordView, { passive: true });
    window.addEventListener('resize', recordView, { passive: true });
    recordView();
  }

  // Re-check the rendered CTA if its content changes without a page navigation.
  new MutationObserver(recordView).observe(button, {
    attributes: true, attributeFilter: ['href'], childList: true, characterData: true, subtree: true
  });

  // The existing Clarity app may load after this deferred script. Never load a second copy.
  function waitForClarity() {
    recordView();
    if (canMeasure() || ++attempts >= 120) return;
    retryTimer = window.setTimeout(waitForClarity, 1000);
  }
  waitForClarity();
  window.addEventListener('pagehide', () => window.clearTimeout(retryTimer));
})();
